<template>
	<div class="itemMain">
		<!-- <h2 class="htitle">{{data.type==1?'技术分享':(data.type==2?'生活点滴':(data.type==3?'经典美文':'其他'))}}</h2> -->
		<h1 class="con_tilte">{{obj.title}}</h1>
		<p class="bloginfo">
			<i class="avatar">
				<img src="../../../public/images/201303152210276757.jpg" alt="">
			</i>
			{{obj.author}}
			<span>{{obj.create_date|dateTrans}}</span>
			<span>【{{obj.type==1?'技术分享':(obj.type==2?'生活点滴':(obj.type==3?'经典美文':'其他'))}}】</span>
			<span>{{obj.reads}}人已阅读</span>
		</p>
		<p class="con_info">
			<b>简介</b>
			{{obj.brief}}
		</p>
		<!-- 下面的div是需要循环的 -->
		<div class="con_text" v-for="(item,index) in obj.content" :key="index">
			<p>{{item.p}}</p>
			<h4 v-if="item.h">{{item.h}}</h4>
			<!-- 下面的p标签是需要循环的 -->
			<p class="imgsP" v-for="(ite,ind) in item.pic" :key="ind">
				<img :src="ite" alt="">
			</p>
		</div>
		<!-- 点赞按钮 -->
		<div class="fabulous">
			<p @click="addSupport">很赞哦！(<span>{{obj.support}}</span>)</p>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			obj:{
				required:false,
				type:Object
			}
		},
		methods:{
			addSupport(){
				this.$emit('support',{type:this.obj.type,id:this.obj.id});
			}
		}
	}
	
	
</script>

<style scoped>
	.itemMain {
		background: #fff;
		border-radius: 3px;
		padding: 20px;
		box-sizing: border-box;
		margin-bottom: 20px;
		overflow: hidden;
	}

	.htitle {
		font-size: 16px;
		line-height: 40px;
		border-bottom: 1px solid #eee;
		color: #484848;
		font-weight: normal;
		position: relative;
		margin-bottom: 10px;
	}

	.htitle:after {
		content: "";
		position: absolute;
		width: 60px;
		height: 2px;
		content: "";
		background: #000;
		left: 0;
		bottom: 0;
		-moz-transition: all .5s ease;
		-webkit-transition: all .5s ease;
		transition: all .5s ease;
	}

	.con_tilte {
		font-size: 22px;
		margin-top: 20px;
		font-weight: bold;
	}

	.bloginfo {
		margin-top: 20px;
		overflow: hidden;
		color: #999;
		line-height: 34px;
	}

	.avatar {
		position: relative;
		float: left;
		width: 30px;
		height: 30px;
		border-radius: 100%;
		padding: 2px;
		display: block;
		background: -webkit-linear-gradient(bottom left, rgba(0, 153, 255, .9), rgba(42, 228, 197, .7));
		background: -o-linear-gradient(bottom left, rgba(0, 153, 255, .9), rgba(42, 228, 197, .7));
		background: linear-gradient(to top right, rgba(0, 153, 255, .9), rgba(42, 228, 197, .7));
	}

	.avatar img {
		width: 100%;
		border-radius: 50%;
		height: 30px;
	}

	.avatar::after {
		content: "";
		position: absolute;
		background: url(../../assets/images/v.png) no-repeat;
		background-size: 12px;
		width: 12px;
		height: 12px;
		right: 0;
		bottom: 0;
	}

	.bloginfo span {
		margin: 0 5px;
	}

	.con_info {
		color: #888888;
		border: 1px solid #F3F3F3;
		padding: 10px;
		margin: 10px auto 0;
		line-height: 23px;
		background: none repeat 0 0 #F6F6F6;
	}

	.con_info b {
		margin-right: 10px;
		color: #000;
		font-weight: bold;
	}

	.con_text {
		line-height: 24px;
		padding-top: 14px;
	}
	.con_text p:first-child{
		text-indent: 32px;
	}

	.con_text h4 {
		font-weight: bold;
		padding-top: 14px;
	}

	.imgsP {
		width: 90%;
		margin: 20px auto;
	}

	.imgsP img {
		width: 100%;
		height: auto;
	}

	.fabulous {}

	.fabulous p {
		width: 160px;
		margin: 20px auto;
		background: #E2523A;
		color: #fff;
		box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, .2);
		border-radius: 3px;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}
	.fabulous p:hover{
		text-decoration: underline;
	}
	.fabulous p span{
		font-weight: bold;
	}
</style>
